import { jsx as _jsx } from "react/jsx-runtime";
import { withStyle } from 'styletron-react';
import { zIndexes } from '../../const/zIndexes';
import { StyledPositionLayoutBase, positionLayoutBasePropsToStyledProps, } from './PositionLayoutBase';
const StyledStickyContainer = withStyle(StyledPositionLayoutBase, {
    position: 'sticky',
    zIndex: zIndexes.stickyContainer,
});
export const StickyContainer = ({ children, ...positionLayoutBaseProps }) => {
    return (_jsx(StyledStickyContainer, { ...positionLayoutBasePropsToStyledProps(positionLayoutBaseProps), children: children }));
};
